import React, {Component} from 'react';
import {Grid, Row, Col, ControlLabel, FormControl} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import KlienciService from "../KlienciService";
import KlienciForm from "./components/KlienciForm";
import {TopButtonAdd} from "../../../componentsTopsa/buttons/TopButtons";
import TopIf from "../../../componentsTopsa/if/TopIf";
import KlienciTable from "./components/KlienciTable";
import ReactNotify from 'react-notify';
import LSService from "../../../utilities/localStorageService/LSService";
import {TopAlertInformacja} from "../../../componentsTopsa/alerty/TopAlerts";
import ScrollUtilities from "../../../utilities/ScrollUtilities";

export default class KlienciContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            klienci: [],
            pokazFormularz: false,
            edytowany: null,
            czyPrzekierowac: null,
            czyPowrotDoStronyKlienta: false,
            strona: 1,
            ilosc: 15,
            pageable: {
                first: false,
                last: false,
                page: 0,
                size: 0,
                totalElements: 0,
                totalPages: 0,
            },
            szukanyCiag: '',
            trwaSzukanie: false,

        };
        this.onClickZapisz = this.onClickZapisz.bind(this)
        this.onClickZamknijForm = this.onClickZamknijForm.bind(this)
        this.onClickEdytuj = this.onClickEdytuj.bind(this)
        this.onClickUsun = this.onClickUsun.bind(this)
        this.onChangeSearchfield = this.onChangeSearchfield.bind(this)
        this.onSizePerPageList = this.onSizePerPageList.bind(this)
        this.onPageChange = this.onPageChange.bind(this)
    }

    componentDidMount() {
        this.pobierzKlientow()
        if (Boolean(LSService.pobierzInformacjeODodaniuKlientaPrzezDodawanieBiletow())) {
            this.setState({
                pokazFormularz: true,
                czyPrzekierowac: LSService.pobierzInformacjeODodaniuKlientaPrzezDodawanieBiletow()
            })
            LSService.usunInformacjeODodaniuKlientaPrzezDodawanieBiletow()
        }
    }

    pobierzKlientow(strona = this.state.strona, ilosc = this.state.ilosc, szukanyCiag = this.state.szukanyCiag) {

        this.setState({trwaSzukanie: true})
        let ciag = null;
        if (szukanyCiag.length > 2) {
            ciag = szukanyCiag
        }

        KlienciService.getKlienciPageable(strona - 1, ilosc, ciag).then(function (response) {
            if (response) {
                this.setState({
                    klienci: response.data.content,
                    pageable: {
                        first: response.data.first,
                        last: response.data.last,
                        page: response.data.number,
                        size: response.data.size,
                        totalElements: response.data.totalElements,
                        totalPages: response.data.totalPages,
                    },
                    trwaSzukanie: false
                })
            }
            else {
                console.log('Wystąpił problem z pobraniem klientów')
                this.setState({
                    klienci: [],
                    pageable: {
                        first: false,
                        last: false,
                        page: 0,
                        size: 0,
                        totalElements: 0,
                        totalPages: 0,
                    },
                    trwaSzukanie: false
                })
            }

        }.bind(this)).catch(function (err) {
            this.setState({trwaSzukanie: false})
        }.bind(this))

    }

    onClickZamknijForm() {
        this.setState({
            pokazFormularz: false,
            edytowany: null,
        })
    }

    onClickZapisz(obj, czyEdycja) {
        if (czyEdycja) {
            KlienciService.editKlient(obj.idKl, obj).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie edytowano klienta', "", 3000)
                    this.pobierzKlientow()
                    if (this.state.czyPowrotDoStronyKlienta) {
                        this.props.history.push('/zarzadzanie-klientami/klient/' + obj.idKl)
                        this.setState({
                            czyPowrotDoStronyKlienta: false
                        })
                    }
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas edycji klienta', "", 3000)
                }

                this.onClickZamknijForm();
            }.bind(this))
        } else {

            KlienciService.addKlient(obj).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie dodano klienta', "", 3000)
                    this.pobierzKlientow()
                    if (Boolean(this.state.czyPrzekierowac)) {

                        let nowy = response.data

                        let imieNazwisko = response.data.imie + ' ' + response.data.nazwisko
                        let informacje = imieNazwisko + ' ' + response.data.pesel
                        let wszystko = informacje + ' ' + response.data.nrTel + ' ' + response.data.email
                        nowy = Object.assign(nowy, {imieNazwisko: imieNazwisko}, {informacje: informacje}, {wszystko: wszystko})

                        LSService.przeslijInformacjeONowoUtworzonymKliencie(nowy)

                        if (this.state.czyPrzekierowac == 'msc') {
                            this.props.history.push('/konfiguracja/zarzadzanie-klientami/karty')
                        }
                        else {
                            this.props.history.push('/konfiguracja/zarzadzanie-biletami/bilety/dodaj-jednorazowy')
                        }
                    }
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas dodawania klienta', "", 3000)
                }

                this.onClickZamknijForm()
            }.bind(this)).catch(err => {
                alert('Podany PESEL istnieje już w bazie!')
            })
        }
    }

    onClickEdytuj(obj) {
        ScrollUtilities.scrollToTop()

        KlienciService.getKlient(obj.idKl).then(function (response) {

            let objzdj = obj

            let zdjecieProfilowe = null
            let zdjeciaSkany = []

            if (response.data.pliki.length > 0) {
                zdjecieProfilowe = response.data.pliki.find(p => p.dokumentTyp == 'KLIENT_ZDJECIE');
                zdjeciaSkany = response.data.pliki.filter(p => p.dokumentTyp == 'KLIENT_DOK_SKAN');
            }


            objzdj = Object.assign(objzdj, {zdjecieProfilowe: zdjecieProfilowe})
            objzdj = Object.assign(objzdj, {zdjeciaSkany: zdjeciaSkany})

            this.setState({pokazFormularz: true, edytowany: objzdj})
        }.bind(this))

    }

    onClickUsun(obj) {
        if (window.confirm('Czy usunąc klienta: ' + obj.imie + ' ' + obj.nazwisko)) {
            KlienciService.deleteKlient(obj.idKl).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie usunięto klienta', "", 3000)
                    this.pobierzKlientow()
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas usuwania klienta', "", 3000)
                }
            }.bind(this))

        }
    }

    onChangeSearchfield(e) {
        this.setState({szukanyCiag: e.target.value})
        if (e.target.value.length > 2) {
            this.pobierzKlientow(this.state.strona, this.state.ilosc, e.target.value)
        }
        else if (e.target.value.length === 0) {
            this.pobierzKlientow(this.state.strona, this.state.ilosc, '')
        }
    }

    onSizePerPageList(size) {
        this.setState({ilosc: size})
    }

    onPageChange(page, sizePerPage) {
        this.setState({strona: page})
        this.pobierzKlientow(page, sizePerPage, this.state.szukanyCiag)
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'KlienciContainer'}>
                    <TopIf isTrue={this.state.trwaSzukanie}>
                        <div id={'GenerowanieContainer'}>
                            <h1>
                                <i className={'fa fa-spinner fa-spin'}></i>
                                <div>
                                    Trwa szukanie rekordów...
                                </div>
                                <h6>
                                    Proces ten może potrwać dłuższą chwilę
                                </h6>
                            </h1>
                        </div>
                    </TopIf>
                    <ReactNotify ref='notificator'/>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{
                                    addressUrl: '/zarzadzanie-klientami',
                                    text: 'Zarządzanie klientami'
                                }, {addressUrl: '/zarzadzanie-klientami/klienci', text: 'Klienci'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>

                        <Col sm={12}>
                            <TopIf isTrue={this.state.pokazFormularz}>
                                <KlienciForm handleClickAnuluj={this.onClickZamknijForm} handleClickZapisz={this.onClickZapisz}
                                             edytowany={this.state.edytowany} nowyPrzezMiesieczny={Boolean(this.state.czyPrzekierowac == 'msc')}/>
                            </TopIf>
                        </Col>
                        <Col xs={12} lg={3}>
                            <ControlLabel>Wyszukaj po nazwisku bądź po emailu:</ControlLabel>
                            <FormControl onChange={this.onChangeSearchfield} placeholder={'Nazwisko lub email (min 3 znaki)'}/>
                            <TopAlertInformacja text={'Minimum 3 znaki, automatyczne szukanie'}/>
                        </Col>
                        <Col xs={12} lg={9}>
                            <TopIf isTrue={!this.state.pokazFormularz}>
                                <div className={'pull-right'} style={{marginTop: '20px'}}>
                                    <TopButtonAdd onClick={() => {
                                        this.setState({pokazFormularz: true});
                                        ScrollUtilities.scrollToTop()
                                    }}/>
                                </div>
                            </TopIf>
                        </Col>
                        <Col xs={12}>
                            <KlienciTable handleEdytuj={this.onClickEdytuj} handleUsun={this.onClickUsun} data={this.state.klienci}
                                          pageable={this.state.pageable}
                                          ilosc={this.state.ilosc}
                                          strona={this.state.strona}
                                          onSizePerPageList={this.onSizePerPageList}
                                          onPageChange={this.onPageChange}
                                          czySzukanyCiag={this.state.szukanyCiag.length > 2}
                            />
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/klienciConfig/klienci/KlienciContainer.js